import { RefObject, Suspense } from 'react';
import { EmptyState, Center } from '@cad-arc';
import { ApiFederatedQueriesRequest } from 'mark43-federated-search/dist/lib/generated/api-types/models-federated-query-ApiFederatedQueriesRequest';
import { FederatedQueryResultDetailsExternalProps } from 'mark43-federated-search/dist/lib/components';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FailedToLoadError } from '../common/components/failed-to-load-error';
import { lazyLoadFederatedSearchModule } from './federated-search-remote-monitor';
import { ErrorBoundary } from '../monitoring/error-boundary';

type FederatedQueryResultDetailsListType = typeof import('federated-search/FederatedQueryResultDetailsList').FederatedQueryResultDetailsList;

const FederatedQueryResultDetailsList = lazyLoadFederatedSearchModule<FederatedQueryResultDetailsListType>(
    'FederatedQueryResultDetailsList',
    () => import('federated-search/FederatedQueryResultDetailsList'),
    (module) => module.FederatedQueryResultDetailsList as FederatedQueryResultDetailsListType,
    () => <FailedToLoadError noun="Universal Search results" />
);

type FederatedSearchQueryResultsProps = {
    filters: ApiFederatedQueriesRequest | undefined;
    renderButtons: FederatedQueryResultDetailsExternalProps['renderButtons'];
    eventNumber: number | undefined;
    exportButtonContainerRef: RefObject<HTMLElement> | undefined;
    downloadFiles:
        | ((
              files: {
                  name: string;
                  url: string;
              }[]
          ) => Promise<void> | void)
        | undefined;
};

export function FederatedSearchQueryResults(props: FederatedSearchQueryResultsProps) {
    return props.filters?.federatedQueryIds?.length ? (
        <ErrorBoundary
            name="FEDERATED_SEARCH_QUERY_RESULTS"
            extraTags={{ feature: 'federated-search' }}
            fallback={() => <FailedToLoadError noun="Universal Search results" />}
        >
            <Suspense fallback={<LoadingIndicator />}>
                <FederatedQueryResultDetailsList {...props} />
            </Suspense>
        </ErrorBoundary>
    ) : (
        <Center height="100%">
            <EmptyState title="No Query Results" />
        </Center>
    );
}
